import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../fxms/datas/DateUtil";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

HighchartsMore(Highcharts);
noDataToDisplay(Highcharts);

Highcharts.setOptions({
  lang: {
    noData: "데이터가 존재하지 않습니다",
  },
  noData: {
    style: {
      fontSize: "16px",
      color: "#999999"
    }
  }
});

class High extends Component {
  render() {
    const { psItem, ranges, averages, data, uiName, fields, input } = this.props;
    const timeData = input.gubun;
    const psName = psItem ? psItem.psName : "";
    const psUnit = psItem ? psItem.psUnit : "";

    function transX(val) {
      const dt = val.substr(4, 6);
      return (
        dt.slice(0, 2) + "/" + dt.slice(2, 4) + " " + dt.slice(4, 6) + "시"
      );
    }
    const title = fields.title;

    let date1 = []; // 일시
    let date2 = [];
    let value1 = []; // 실제생산량
    let value2 = []; // 예측생산량

    for (let datas of data) {
      if (datas.consPredic) {
        date2.push(DateUtil.makeDate(datas[fields.date2]).getTime());

        const value1Item = datas[fields.value1];
        const value2Item = datas[fields.value2];
        if (value1Item) {
          value1.push(datas[fields.value1]);
        }
        if (value2Item) {
          value2.push(datas[fields.value2]);
        }
      } else {
        date1.push(DateUtil.makeDate(datas[fields.date1]).getTime());

        const value1Item = datas[fields.value1];
        const value2Item = datas[fields.value2];
        if (value1Item) {
          value1.push(datas[fields.value1]);
        }
        if (value2Item) {
          value2.push(datas[fields.value2]);
        }
      }
    }

    // console.log("date1 : " + date1);
    // console.log("date2 : " + date2);
    // console.log("value1 : " + value1);
    // console.log("value2 : " + value2);


    // 실제 data 가져오는 함수
    function realAmt() {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        let value = data[i][fields.value1];
        if (date1[i] !== undefined && value !== undefined) {
          result.push([date1[i], value || 0]);
        }
      }
      return result;
    }

    // 예측 data 가져오는 함수
    function expAmt(fields) {
      let result = [];

      for (let i = 0; i < data.length; i++) {
        if (fields.date1 == fields.date2) {
          if (date1[i] !== undefined && value2[i] !== undefined) {
            result.push([date1[i], value2[i]]);
          }
        } else {
          if (date2[i] !== undefined && value2[i] !== undefined) {
            result.push([date2[i], value2[i]]);
          }
        }
      }
      return result;
    }

    const series = [];

    if (fields.value1) {
      series.push({
        name: fields.Label1,
        data: realAmt(),
        lineWidth: 2,
        color: fields.value2 ? Highcharts.getOptions().colors[0] : "#66B2FF",
        fillOpacity: 0.4,
        zIndex: 1,
        lineColor: "#0080FF",
        marker: {
          fillColor: "white",
          lineWidth: 2,
          lineColor: "blue",
        },
        pointWidth: 30, // bar width 설정
        nullHandling: 'zero',
      })
    }

    if (fields.value2) {
      series.push({
        name: fields.value2 ? fields.Label2 : "",
        data: fields.value2 ? expAmt(fields) : [],
        lineWidth: 2,
        lineColor: "#FA5A5A",
        marker: {
          fillColor: "white",
          lineWidth: 2,
          lineColor: "red",
        },
        nullHandling: 'zero',
      })
    }

    const options = {
      chart: {
        backgroundColor: "rgba(255,255,255, 0.1)",
        type: fields.chartType,
      },

      title: {
        text: title,
        style: { color: "white" },
      },

      xAxis: {
        type: "datetime",
        lineColor: '#555',
        labels: {
          style: {
            color: "rgba(255,255,255,0.8)"
          },
          formatter: function () {
            if (fields.xAxisType) {
              return new Date(this.value).toLocaleString('default', { month: 'short' })
            } else if (timeData === 'realtime') {
              return new Date(this.value).toLocaleString('default', { day: 'numeric', hour: 'numeric', minute: 'numeric' });
            } else if (timeData === 'hour') {
              return new Date(this.value).toLocaleString('default', { month: 'short', day: 'numeric', hour: '2-digit' });
            } else if (timeData === 'day') {
              return new Date(this.value).toLocaleString('default', { month: 'short', day: 'numeric' });
            } else if (timeData === 'month') {
              return new Date(this.value).toLocaleString('default', { year: 'numeric', month: 'short' });
            } else if (timeData === 'year') {
              return new Date(this.value).toLocaleString('default', { year: 'numeric' });
            } else {
              return new Date(this.value).toLocaleString('default', { dateStyle: 'short' });
            }
          }
        },
      },

      yAxis: {
        title: {
          text: psUnit,
        },
        labels: {
          style: {
            color: "rgba(255,255,255,0.8)"
          }
        },
        lineWidth: 1,
        lineColor: '#555',
        gridLineColor: '#555'
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        pointFormatter: function () {
          return '<span style="color:' + this.color + '">●</span> ' + this.series.name + ': <b>' +
            Highcharts.numberFormat(this.y, 0, '.', ',') + psUnit + '</b><br/>';
        }
      },

      legend: {
        itemStyle: {
          color: 'rgba(255,255,255,0.9)',
          fontWeight: '400'
        }
      },

      connectNulls: true,

      plotOptions: {
        column: {
          //pointPadding: 0.2,
          borderWidth: 0,     // 바 border 가 없도록 설정
          groupPadding: 0.5,  // 바가 중앙에 정렬되도록 설정
        },
        line: {
          nullHandling: 'zero'
        },
        bar: {
          nullHandling: 'zero'
        }
      },
      series: series
    };

    return (
      <>
        <HighchartsReact
          containerProps={{ style: { height: "92%" } }}
          highcharts={Highcharts}
          options={options}
        />
      </>
    );
  }
}

export const FxLineChart = (props) => {
  const { data, uiName, fields, input } = props;

  return (
    <>
      <High
        data={data}
        uiName={uiName}
        fields={fields}
        input={input}
      />
    </>
  );
};

export default FxLineChart;
